import { inject, Injectable } from '@angular/core';
import { ApiServiceBase } from '@twist/core';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { OrganizationFeaturesBackboneService, GetAllOrganizationFeaturesQueryResult } from '@twist/backbone-api-services/ciam';

@Injectable({ providedIn: 'root' })
export class FeaturesService extends ApiServiceBase{
  private backboneService = inject(OrganizationFeaturesBackboneService);

  getAllFeatures = (): Promise<GetAllOrganizationFeaturesQueryResult> => {
    return new Promise<GetAllOrganizationFeaturesQueryResult>((resolve, reject) => {
      firstValueFrom(
        this.backboneService.getAllFeatures()
      )
        .then((result) => {
          resolve(result);
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };
}
